/* @flow */

import * as React from 'react';

import capitalize from 'underscore.string/capitalize';

import type {DeviceType} from '../../../types';

import {DesktopIcon, TabletIcon, CellPhoneIcon} from '../../../../icon';
import {StackLegacy} from '../../../../layout';
import {Divider} from '../../../../layout/divider';

import './session-metadata.module.css';

type Props = {
    locationSummary: ?string,
    deviceType: DeviceType,
    platformType: ?string,
};

export function SessionMetadata(props: Props) {
    const {locationSummary, deviceType} = props;
    const platformType = props.platformType === 'Unknown' ? undefined : props.platformType;

    let Icon: ?React.ComponentType<*> = null;
    // This is only used for the icon
    switch (deviceType) {
        case 'desktop':
            Icon = DesktopIcon;
            break;
        case 'tablet':
            Icon = TabletIcon;
            break;
        case 'mobile':
            Icon = CellPhoneIcon;
            break;
    }

    const capitalizeLocationSummary = (location: string): string => {
        // Turns 'ann arbor, MI' to 'Ann Arbor, MI'
        return location
            .split(' ')
            .map((word) => capitalize(word))
            .join(' ');
    };

    return platformType || locationSummary ? (
        <div styleName='session-metadata'>
            {platformType ? (
                <StackLegacy spacing={8} isHorizontal={true}>
                    <div>{Icon ? <Icon size={15} /> : undefined}</div>
                    {platformType}
                </StackLegacy>
            ) : undefined}
            {platformType && locationSummary ? <Divider variant='dot' spacing={6} /> : undefined}
            {locationSummary ? <div>{capitalizeLocationSummary(locationSummary)}</div> : undefined}
        </div>
    ) : null;
}
